<template>
  <BaseModalSmall @close="$emit('close')">
    <BaseText size="l">
      {{ $t('register.salonized_pay.subscription_required.message', brandNamePay()) }}
    </BaseText>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="$emit('close')"
        v-test="'sp-subscription-modal-cancel'"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        :routerLink="{
          name: 'subscription',
          query: {
            action: isTrial ? 'subscribe' : 'upgrade',
            requiredPlan: 'basic'
          }
        }"
        v-test="'sp-subscription-modal-upgrade'"
      >
        {{ isTrial
            ? $t('register.salonized_pay.subscription_required.subscribe_now')
            : $t('register.salonized_pay.subscription_required.upgrade_now') }}
      </BaseButton>
    </template>
  </BaseModalSmall>
</template>

<script
  setup
  lang="ts"
>
import { brandNamePay } from '@/helpers/brand-name';
import { useCompanyStore } from '@/stores/company';

defineEmits(['close']);

const { isTrial } = useCompanyStore();
</script>
